import type { ListingAvailability } from '@bb/domain/dist/types';
import { featureEnabled } from './featureFlagBrowserClient';

const ACTIVE_AVAILABLITY = [
  'New',
  'Price Change',
  'Deal Fell Through',
  'Sold Conditionally',
  'Extended',
  'Leased Conditionally',
  'Show For Backups',
];

const isListingAvailable = (listing: { availability: ListingAvailability }) =>
  ACTIVE_AVAILABLITY.includes(listing.availability);

export default isListingAvailable;
